module.exports = __webpack_public_path__ + "static/media/Rock_suite.34bf918c.png";